export class RequiredPermissionGuard {
    requiredPermissions: string[] = [];

    constructor(permissions?: string[]) {
        this.requiredPermissions = permissions ?? [];
    }
}